// Archive generators are classified for analysis without entering the published
// course or its random task pool before a separate review.
export const MATURA_ARCHIVE_TASK_TYPE_CODE3 = Object.freeze({
  MaturaBasic_DivisionRemainderQuotient: "1.3.1",
  MaturaBasic_CubeRootsProductQuotient: "1.4.3",
  MaturaBasic_ThreePowerBasesProductQuotient: "1.4.3",
  MaturaBasic_LogarithmRootOfBaseRoot: "1.5.1",
  MaturaBasic_FourthPowersSymmetricDivisibility: "10.1.1",
  MaturaBasic_SquareFractionProductCancellation: "2.1.3",
  MaturaBasic_PolynomialProductRealRootCount: "2.7.4",
  MaturaBasic_ProductShiftedStrictQuadraticInequality: "2.3.2",
  MaturaBasic_SymmetricLinearSystemSignsTruth: "2.4.1",
  MaturaBasic_LinearParameterMonotonicityInterceptTruth: "3.2.1",
  MaturaBasic_DiscontinuousGraphMonotonicityTruth: "3.1.2",
  MaturaBasic_DiscontinuousGraphMaximumLevelCount: "3.1.2",
  MaturaBasic_DiscontinuousGraphDomainSublevel: "3.1.2",
  MaturaBasic_ParabolaRootsVertexTriangleArea: "3.3.2",
  MaturaBasic_InverseProportionTable: "3.9.1",
  MaturaBasic_RationalSequenceArithmeticThreeTerms: "4.2.1",
  MaturaBasic_RecursiveArithmeticInitialSum: "4.2.2",
  MaturaBasic_DecreasingGeometricEvenIndexRatio: "4.3.1",
  MaturaBasic_ObtuseSineOverTangent: "5.1.2",
  MaturaBasic_RightTriangleLegFromTangent: "5.1.2",
  MaturaBasic_TriangleIncircleCenterDefinition: "6.1.3",
  MaturaBasic_DiameterChordIntersectionAngle: "6.3.2",
  MaturaBasic_IsoscelesTrapezoidBisectorProof: "10.2.1",
  MaturaBasic_CircleMinusInscribedHexagonArea: "6.3.1",
  MaturaBasic_ImplicitParallelLinesParameter: "7.2.3",
  MaturaBasic_SquareDiagonalReflectedCircumcircle: "7.3.1",
  MaturaBasic_CubeDiagonalEquilateralAreaEdge: "8.1.1",
  MaturaBasic_SquarePyramidFaceBaseAngleVolume: "8.2.3",
  MaturaBasic_SimilarCylinderAreaVolumeTruth: "8.3.1",
  MaturaBasic_TwoDigitMultipleProbability: "9.2.1",
  MaturaBasic_WeightedGradesGroupedTable: "9.3.1",
  MaturaBasic_GoalsPieChartMedian: "9.3.2",
  MaturaBasic_VertexFormIntervalMaximumArgument: "3.3.2",
  MaturaBasic_VertexFormIntervalMinimumArgument: "3.3.2",

  MaturaRegionColoringTreeClosedTask: "9.1.1",
  MaturaBasic_OddRootQuotient: "1.4.3",
  MaturaBasic_SameBasePowerQuotient: "1.4.3",
  MaturaBasic_LogarithmOfRootPower: "1.5.1",
  MaturaBasic_CubicCommonFactorSquare: "2.1.2",
  MaturaBasic_ThreeConsecutivePowersDivisibility: "10.1.1",
  MaturaBasic_SubtractPolynomialProduct: "2.1.1",
  MaturaBasic_FactoredQuadraticStrictClosed: "2.3.2",
  MaturaBasic_RationalQuadraticRestrictedRoot: "2.2.3",
  MaturaBasic_TreesSystemModel: "2.4.2",
  MaturaBasic_LinearMonotonicityInterceptTruth: "3.2.1",
  MaturaBasic_QuadraticRootUnknownCoefficient: "3.3.2",
  MaturaBasic_ParabolaEqualValuesVertex: "3.3.2",
  MaturaBasic_ParabolaVertexHorizontalShift: "3.3.2",
  MaturaBasic_RecursiveArithmeticPropertiesTruth: "4.2.1",
  MaturaBasic_ArithmeticFourTermSumSecond: "4.2.2",
  MaturaBasic_FiveGeometricTermsProduct: "4.3.1",
  MaturaBasic_RightTriangleShortLegSine: "5.1.2",
  MaturaBasic_ObtuseCosineGivenSine: "5.1.2",
  MaturaBasic_SquarePerimeterAdjacentCoordinates: "7.1.2",
  MaturaBasic_SquarePyramidAllEdgesHeight: "8.2.1",
  MaturaBasic_ConeLateralAreaOpeningTruth: "8.3.2",
  MaturaBasic_EvenNumberEqualEndDigits: "9.1.1",
  MaturaBasic_WeightedSchoolAgeMean: "9.3.1",
  MaturaBasic_WithoutReplacementEvenProduct: "9.2.1",
  MaturaBasic_ThreeBranchGraphZerosMaximum: "3.1.2",
  MaturaBasic_ThreeBranchGraphDomainNonnegative: "3.1.2",
  MaturaBasic_DiameterInscribedComplementAngle: "6.3.2",
  MaturaBasic_ParallelTriangleSideScale: "6.1.7",
  MaturaBasic_ParallelogramDiagonalCenterLinesMidpoint: "7.1.3",
  MaturaBasic_CylinderDiagonalVolumeTotalArea: "8.3.1",
  MaturaBasic_GradesBarChartMedianClosed: "9.3.2",
  MaturaBasic_SquareInscribedTriangleOptimization: "3.3.6",
});

export const MATURA_TASK_TYPE_CODE3 = {
  MaturaExponentialModelOpenTask: "3.5.1",
  MaturaAbsoluteValueInequalityOpenTask: "2.3.3",
  MaturaAbsoluteValueEquationOpenTask: "2.2.4",
  MaturaConditionalDiceFacesOpenTask: "9.2.3",
  MaturaTrigTanQuadraticEquationOpenTask: "5.3.2",
  MaturaQuadraticVietaSameSignDistanceParamOpenTask: "3.3.7",
  MaturaExtendedAlgebraInequalityProofTask: "10.1.2",
  MaturaExtendedTrapezoidProofTask: "10.2.1",
  MaturaExtendedConeVolumeProofTask: "10.2.3",
  MaturaExtendedEquilateralAreaAngleTask: "6.1.3",
  MaturaExtendedConvergentGeometricTask: "4.3.2",
  MaturaExtendedCircleVectorTask: "7.3.3",
  MaturaExtendedPyramidDihedralTask: "8.2.2",
  MaturaExtendedConeOptimizationTask: "3.7.4",
  MaturaAbsValueClosedTask: "1.1.2",
  MaturaAbsoluteValueEquationClosedTask: "2.2.4",
  MaturaArcLengthClosedTask: "6.3.1",
  MaturaArithGeoSignsClosedTask: "4.2.1",
  MaturaArithmeticDifferenceClosedTask: "4.2.1",
  MaturaArithmeticSumClosedTask: "4.2.2",
  MaturaArithmeticTermClosedTask: "4.2.1",
  MaturaArithmeticTripletParamOpenTask: "4.2.1",
  MaturaAxisZeroPointCanonicalOpenTask: "3.3.2",
  MaturaBarChartStatsOpenTask: "9.3.2",
  MaturaBarChartPercentageComparisonOpenTask: "1.2.4",
  MaturaBinomialDifferencePolynomialClosedTask: "2.1.2",
  MaturaBinomialRootValueClosedTask: "2.1.2",
  MaturaCentralFromInscribedClosedTask: "6.3.2",
  MaturaCircleAxesClosedTask: "7.3.1",
  MaturaCircleCenterPointEquationClosedTask: "7.3.1",
  MaturaCircleDiameterEquationClosedTask: "7.3.1",
  MaturaCircleSymmetryClosedTask: "7.3.1",
  MaturaConeHeightClosedTask: "8.3.2",
  MaturaConeVolumeOpeningOpenTask: "8.3.2",
  MaturaCosineSideClosedTask: "6.1.9",
  MaturaCosineGivenValueOpenTask: "6.1.9",
  MaturaCubeVolumeDiagonalClosedTask: "8.1.3",
  MaturaCuboidGeoSequenceVolumeOpenTask: "4.3.4",
  MaturaCuboidSurfaceOptimizationOpenTask: "3.3.6",
  MaturaCubicRootsSumClosedTask: "2.2.5",
  MaturaCylinderHeightClosedTask: "8.3.1",
  MaturaDifferenceSquaresClosedTask: "2.1.2",
  MaturaDigitOnceClosedTask: "9.1.1",
  MaturaFactoredRealRootsClosedTask: "2.2.5",
  MaturaFactoredQuadraticInequalityOpenTask: "2.3.2",
  MaturaFactoredRootsSumParameterClosedTask: "2.2.5",
  MaturaGeometricParamClosedTask: "4.3.1",
  MaturaGeometricEdgeRatioOpenTask: "4.3.1",
  MaturaGeometricRatioClosedTask: "4.3.1",
  MaturaGeometricTermClosedTask: "4.3.1",
  MaturaGradesMedianModeOpenTask: "9.3.2",
  MaturaInscribedCentralBaseAngleClosedTask: "6.3.2",
  MaturaLinearExtremeInequalityClosedTask: "2.3.1",
  MaturaLinearInequalityClosedTask: "2.3.1",
  MaturaLinearInequalityGraphClosedTask: "2.3.1",
  MaturaLinearKIntervalClosedTask: "3.2.1",
  MaturaLinearNoZeroClosedTask: "3.2.1",
  MaturaLinearShiftClosedTask: "3.2.1",
  MaturaLinearZeroAndValueClosedTask: "3.2.1",
  MaturaLinesParamRelationOpenTask: "7.2.3",
  MaturaLogCoefSumTruthClosedTask: "1.5.2",
  MaturaLogPropClosedTask: "1.5.2",
  MaturaLogSingleCoefClosedTask: "1.5.2",
  MaturaMeanScaledABCClosedTask: "9.3.1",
  MaturaMeanSevenXYSumClosedTask: "9.3.1",
  MaturaNestedRootPowerClosedTask: "1.4.3",
  MaturaMod5SquaresOpenTask: "10.1.1",
  MaturaParallelLinePointOpenTask: "7.2.3",
  MaturaParallelLinesParameterClosedTask: "7.2.3",
  MaturaParityDigitsH00ClosedTask: "9.1.1",
  MaturaPercentLinearSystemBusinessOpenTask: "2.4.2",
  MaturaPercentLinearSystemOpenTask: "2.4.2",
  MaturaCompoundInterestClosedTask: "1.2.4",
  MaturaCompoundInterestFormulaClosedTask: "1.2.4",
  MaturaPiecewiseFunctionContinuousOpenTask: "3.1.2",
  MaturaPiecewiseFunctionIntervalsOpenTask: "3.1.2",
  MaturaPiecewiseFunctionOpenTask: "3.1.2",
  MaturaPolynomialRootsCountClosedTask: "2.2.5",
  MaturaPowerDivisibilityOpenTask: "10.1.1",
  MaturaParityProductDivisibilityOpenTask: "10.1.1",
  MaturaPowerDivisibilityTruthClosedTask: "1.4.3",
  MaturaPowerDivisionClosedTask: "1.4.3",
  MaturaPowerFactorOutClosedTask: "1.4.3",
  MaturaPowerTimesRootClosedTask: "1.4.3",
  MaturaSqrtProductPlusPowerClosedTask: "1.1.5",
  MaturaQuadraticAxisFromGraphClosedTask: "3.3.2",
  MaturaQuadraticAxisShiftClosedTask: "3.3.2",
  MaturaQuadraticBCSignsClosedTask: "3.3.3",
  MaturaQuadraticCanonicalFromGraphOpenTask: "3.3.2",
  MaturaQuadraticFactorClosedTask: "3.3.3",
  MaturaQuadraticInequalityOpenTask: "2.3.2",
  MaturaQuadraticRevenueClosedTask: "3.3.6",
  MaturaQuadraticRevenueOpenTask: "3.3.6",
  MaturaQuadraticSequencePFClosedTask: "4.1.1",
  MaturaQuadraticSequenceS3ClosedTask: "4.1.1",
  MaturaQuadraticShiftBy3ZerosSumOpenTask: "3.3.3",
  MaturaRationalExpressionClosedTask: "2.1.3",
  MaturaLinearRationalEquationClosedTask: "2.2.3",
  MaturaRationalIntervalOpenTask: "2.2.3",
  MaturaRecursiveSequencePFClosedTask: "4.1.3",
  MaturaRecursiveSequenceTermClosedTask: "4.1.3",
  MaturaRegularPolygonInscribedAngleClosedTask: "6.3.2",
  MaturaRemainderDivisibilityOpenTask: "10.1.1",
  MaturaRightTriangleCircumradiusClosedTask: "6.1.3",
  MaturaRightTriangleInradiusClosedTask: "6.1.3",
  MaturaRightTriangleTwoTrigClosedTask: "5.1.2",
  MaturaRootBinomialClosedTask: "1.1.5",
  MaturaRootSumClosedTask: "1.1.5",
  MaturaScaledQuadraticInequalityOpenTask: "2.3.2",
  MaturaSequenceNthTermClosedTask: "4.1.1",
  MaturaSetsProductSumSignOpenTask: "9.2.1",
  MaturaSimilarIsoscelesTriangleClosedTask: "6.1.7",
  MaturaTrapezoidSimilarityLengthOpenTask: "6.1.7",
  MaturaSqrtDifferenceSquareClosedTask: "1.1.5",
  MaturaSquareDiagonalCenterClosedTask: "7.1.3",
  MaturaSquarePyramidBaseEdgeClosedTask: "8.2.1",
  // Zadanie o liczbie ścian/wierzchołków/krawędzi dotyczy zarówno
  // graniastosłupów, jak i ostrosłupów. Jako slot egzaminacyjny traktujemy je
  // jak ogólną stereometrię 8.1.3, aby nie wypierało zadania stricte
  // ostrosłupowego z 8.2.1.
  MaturaPyramidFacesVerticesClosedTask: "8.2.1",
  MaturaSquaresSimilarityAreaClosedTask: "6.5.3",
  MaturaSimilarPyramidsSurfaceScaleOpenTask: "6.5.3",
  MaturaStatsTableMeanMedianModeOpenTask: "9.3.2",
  MaturaTextLinearSystemOpenTask: "2.4.2",
  MaturaTicketRevenueSystemOpenTask: "2.4.2",
  MaturaPiecewiseReadingOpenTask: "3.1.2",
  MaturaLinearCoefficientsGraphTruthClosedTask: "3.2.2",
  MaturaLinearSlopeFromGraphClosedTask: "3.2.2",
  MaturaQuadraticShiftFormulaOpenTask: "3.3.2",
  MaturaLinearSequenceGeometricTripletOpenTask: "4.3.1",
  MaturaArithmeticSymmetricTermClosedTask: "4.2.1",
  MaturaGeometricEqualIndexSumProductOpenTask: "4.3.1",
  MaturaRightTriangleSineClosedTask: "5.1.2",
  MaturaCircleInscribedCentralAngleClosedTask: "6.3.2",
  MaturaParallelLinesSegmentsClosedTask: "6.1.7",
  MaturaAngleBisectorAreaRatioProofOpenTask: "10.2.1",
  MaturaAcuteTriangleAngleProofOpenTask: "10.2.1",
  MaturaTriangleCongruenceProofOpenTask: "10.2.1",
  MaturaTriangleSimilarityProofOpenTask: "10.2.1",
  MaturaTrigTanFromLinearRelationClosedTask: "5.1.4",
  MaturaEquilateralTriangleCircumradiusOpenTask: "6.1.3",
  MaturaCoordinateRightTriangleAreaClosedTask: "7.1.2",
  MaturaRightTriangleCircumcenterCoordinatesClosedTask: "7.1.3",
  MaturaCirclePointEquationTruthClosedTask: "7.3.1",
  MaturaParallelLineYAxisIntersectionClosedTask: "7.2.3",
  MaturaSquarePyramidDiagonalAngleVolumeOpenTask: "8.2.2",
  MaturaConeCylinderVolumeRatioClosedTask: "8.3.2",
  MaturaOddThreeDigitCountingClosedTask: "9.1.1",
  MaturaTwoDigitSetsDivisibilityProbabilityOpenTask: "9.2.1",
  MaturaTwoClassStatsTruthClosedTask: "9.3.2",
  MaturaCombinedGroupMeanClosedTask: "9.3.1",
  MaturaProjectileGroundTimeClosedTask: "3.3.3",
  MaturaProjectileVertexTimeClosedTask: "3.3.6",
  MaturaTrapezoidAreasClosedTask: "6.2.3",
  MaturaTriangleAreaClosedTask: "6.1.2",
  MaturaTriangleSineCosinePFClosedTask: "6.1.9",
  MaturaTriangularPrismVolumeAreaOpenTask: "8.1.3",
  MaturaTrigProductSumClosedTask: "5.1.2",
  MaturaTrigSinCosIdentityClosedTask: "5.2.3",
  MaturaTrigTanFromCosClosedTask: "5.1.2",
  MaturaTrigTanRelationClosedTask: "5.1.4",
  MaturaTrigTrianglePFClosedTask: "5.1.2",
  MaturaTwoDiceNumberOddDiv3OpenTask: "9.2.1",
  MaturaTwoDiceSumEqualsClosedTask: "9.2.1",
};

// Some official tasks deliberately combine independent skills. Keep a single
// primary code for legacy consumers, but expose every relevant course slot.
export const MATURA_TASK_TYPE_ADDITIONAL_CODES = Object.freeze({
  MaturaAngleBisectorAreaRatioProofOpenTask: ["6.1.2", "6.1.1"],
  MaturaAcuteTriangleAngleProofOpenTask: ["6.1.6", "6.1.4"],
  MaturaPyramidFacesVerticesClosedTask: ["8.2.1"],
  MaturaArithGeoSignsClosedTask: ["4.3.1"],
  MaturaCuboidGeoSequenceVolumeOpenTask: ["8.1.3"],
  MaturaPowerDivisibilityTruthClosedTask: ["10.1.1"],
  MaturaQuadraticSequencePFClosedTask: ["4.2.1"],
  MaturaRecursiveSequencePFClosedTask: ["4.2.1", "4.3.1"],
  MaturaTriangleSineCosinePFClosedTask: ["6.1.2"],
  MaturaCirclePointEquationTruthClosedTask: ["7.1.2"],
  MaturaSquarePyramidDiagonalAngleVolumeOpenTask: ["8.2.3"],
  MaturaConeCylinderVolumeRatioClosedTask: ["8.3.1"],
});

export function getMaturaTaskTypeCodes(taskOrType) {
  const type = typeof taskOrType === "string" ? taskOrType : taskOrType?.type;
  const primary = MATURA_TASK_TYPE_CODE3[type] || MATURA_ARCHIVE_TASK_TYPE_CODE3[type] || (typeof taskOrType === "object" ? taskOrType?.classification?.code3 : null);
  if (!primary) return [];
  return Array.from(new Set([primary, ...(MATURA_TASK_TYPE_ADDITIONAL_CODES[type] || [])]));
}

export function getMaturaTaskTypeCode3(taskOrType) {
  return getMaturaTaskTypeCodes(taskOrType)[0] || null;
}
